export const COMPETITOR_LIST = [
    { id: 'home_credit', label: 'Home Credit' },
    { id: 'salmon', label: 'Salmon' },
    { id: 'billease', label: 'Billease' },
    { id: 'skyro', label: 'Skyro' }
];
